import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { Images } from "constants";
import { dashboardCount } from '_services/dashboardService/dashboardService';
import toast from 'react-hot-toast';
import StorageService from 'utils/StorageServices/StorageServices';
import { UserContext } from 'context';
import { CityDropdownForTrip, CommonDateRange, CustomSelect, PieCharts } from 'components';
import moment from 'moment';
import { getBranchDropdownListData, getBranchListApi } from '_services/dropdownServices/dropdownService';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { updateInputValue } from 'features/lrFilterServices/lrFilterSlice';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { updateEwayBillFilters } from 'features/ewayBillFilterServices/ewayBillFilterSlice';
import { IoArrowForwardOutline } from 'react-icons/io5'
import { StorageServices } from 'utils';
import { paymentVerifyApi } from '_services';
import { getUsablityList } from '_services/walletService/walletService';
import { SubscriptionWarnningModal } from 'modals';
import './maindash.css'
import { BsExclamationCircle } from 'react-icons/bs';
import { createPermissionMap } from 'helper/permissions';
import { hasPermission } from 'utils/permissionHelper';


const MainDashboard = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const getFiltersValues = useSelector((state) => state.lrFilter)?.filters;
    const getEwayBillFilters = useSelector((state) => state.ewayBillFilter)?.filters;
    const { masterData, userData, dashboardFilterClear,
        setDashboardFilterClear, setWarningDetails,
        warningDetails, showWarnning, setShowWarnning, setTRipFilter, setNoAccessISOpen, allMenu } = useContext(UserContext)
    const urlParams = new URLSearchParams(window.location.search);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showPending, setShowPending] = useState(false);
    const [showFailure, setShowFailure] = useState(false);

    const [selectedRange, setSelectedRange] = useState({
        startDate: '',
        endDate: '',
    });
    const [dashboardFilter, setDashboardFilter] = useState({
        company_id: StorageService.getCompanyId(),
        branch_id: {},
        consignor_id: '',
        start_date: '',
        end_date: '',
    })
    const [dashboardData, setDashBoardData] = useState({});
    const [dropdownBranchList, setDropdownBranchList] = useState([]);
    const [chartData, setChartData] = useState([]);
    const conmanyId = StorageService.getCompanyId();
    const globleFirmId = StorageService.getFirmId();
    const orderId = Array.from(urlParams.keys())[0];

    useDocumentTitle("Dashboard | T360");

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const firstKey = Array.from(urlParams.keys())[0];

        if (firstKey && firstKey.startsWith("order_")) {
            paymentVerifyHandle(firstKey);
        } else {
            return;
        }
    }, [location.search]);

    const getMainDashboard = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                branch_id: dashboardFilter?.branch_id?.value ? dashboardFilter?.branch_id?.value : '',
                consignor_id: dashboardFilter?.consignor_id?.value ? dashboardFilter?.consignor_id?.value : '',
                start_date: selectedRange?.startDate ? moment(selectedRange?.startDate)?.format("YYYY-MM-DD") : getFiltersValues?.start_date,
                end_date: selectedRange?.endDate ? moment(selectedRange?.endDate)?.format("YYYY-MM-DD") : getFiltersValues?.end_date,
                firm_id: getFiltersValues?.branch_id?.firm_id?._id ? getFiltersValues?.branch_id?.firm_id?._id : StorageService.getFirmId(),
            }
            const res = await dashboardCount(object);
            if (res?.responseCode === 200) {
                setDashBoardData(res?.data)
                getDataForChart(res?.data?.trip_status)
            } else {
                toast.error(`${res?.responseMessage}`);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    useEffect(() => {
        if (conmanyId != "undefined" && conmanyId) {
            getMainDashboard();
        }
    }, [dashboardFilter, selectedRange, conmanyId, globleFirmId])

    const getSubscriptionList = useCallback(async () => {
        try {
            const object = { company_id: StorageService.getCompanyId() };
            const res = await getUsablityList(object);

            if (res?.responseCode === 200 && res?.data?.company) {

                setWarningDetails(res.data.company);
                const days = calculateRemainingDays(res?.data?.company.web_end_date)
                if (days == 0) {
                    setShowWarnning(true)
                }
            }
        } catch (error) {
            toast.error("Failed to fetch subscription details!");
        }
    }, []);

    const calculateRemainingDays = useCallback((endDate) => {
        if (!endDate) return 0;

        const today = new Date();
        const end = new Date(endDate);
        const diffDays = Math.ceil((end - today) / (1000 * 60 * 60 * 24));
        return diffDays >= 0 ? diffDays : 0;
    }, []);

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...dashboardFilter, [name]: item };
        setDashboardFilter(stateObj);
        const obj = {
            ...getFiltersValues,
            branch_id: item,
            start_date: selectedRange?.startDate ? moment(selectedRange?.startDate)?.format("YYYY-MM-DD") : '',
            end_date: selectedRange?.endDate ? moment(selectedRange?.endDate)?.format("YYYY-MM-DD") : '',
            lr_pagination: 1
        }
        dispatch(updateInputValue(obj))
        if (name == "branch_id") {
            setTRipFilter((pre) => ({ ...pre, branch_id: item.value, branch_name: item?.label }))
        }

    };

    const getDataForChart = (data) => {
        const trip_status = data
        const selectedStatuses = ["at_party", "in_transit", "delivered", "cancelled"];

        const filteredTripStatusArray = selectedStatuses?.map(status => ({
            name: status,
            value: trip_status[status]
        }));
        setChartData(filteredTripStatusArray)
    }

    // const getDropdownDataBranchList = async () => {
    //     try {
    //         let object = {
    //             company_id: StorageService.getCompanyId(),
    //             firm_id: StorageService.getFirmId(),
    //             limit: 100,
    //             offset: 1,
    //             search: "",
    //         };
    //         const res = await getBranchDropdownListData(object);
    //         if (res?.responseCode == 200) {
    //             setDropdownBranchList([{ branch: "All", _id: "" }, ...res?.data?.branch_list]);
    //         }
    //     } catch (error) {
    //         // throw error;
    //     }
    // };

    useEffect(() => {
        if (conmanyId != "undefined") {
            getSubscriptionList()
            // getDropdownDataBranchList();
        }

    }, [conmanyId])

    const handleApply = (newRange) => {
        setSelectedRange(newRange);
        const obj = {
            ...getFiltersValues,
            start_date: newRange?.startDate,
            end_date: newRange?.endDate,
            lr_status: 0,
            lr_pagination: 1
        }
        dispatch(updateInputValue(obj))
        setTRipFilter((pre) => ({
            ...pre, start_date: newRange?.startDate,
            end_date: newRange?.endDate,
        }))
    };

    const statusWithNavigate = (value, is_action) => {

        if (!warningDetails?.subscription_data?.web_access) {
            setNoAccessISOpen(true)
            return;
        }

        const hasLinkPermission = hasPermission("/lr/addlr", allMenu, 'web', 'link');

        if (!hasLinkPermission) {
            toast.error("You don't have permission to access this page");
            return;
        }

        navigate('/lr/addlr');
        if (!is_action) {
            setSelectedRange({
                startDate: '',
                endDate: '',
            })
            const obj = {
                ...getFiltersValues,
                start_date: '',
                end_date: '',
                lr_status: value,
                lr_pagination: 1
            }
            dispatch(updateInputValue(obj))
        } else {
            const obj = {
                ...getFiltersValues,
                lr_status: value,
                lr_pagination: 1
            }
            dispatch(updateInputValue(obj))
        }
    }

    const handleApplyFilter = (object) => {
        if (!warningDetails?.subscription_data?.web_access) {
            setNoAccessISOpen(true)
            return;
        }

        const hasLinkPermission = hasPermission("/lr/addlr", allMenu, 'web', 'link');
        if (!hasLinkPermission) {
            toast.error("You don't have permission to access this page");
            return;
        }

        const obj = {
            ...getFiltersValues,
            pod_status: object,
            lr_status: 0,
            lr_pagination: 1
        }
        dispatch(updateInputValue(obj))
        navigate('/lr/addlr');
    }


    const handleApplyNavigation = (link, label = "") => {
        if (!warningDetails?.subscription_data?.web_access) {
            setNoAccessISOpen(true);
            return;
        }


        const hasLinkPermission = hasPermission(link, allMenu, 'web', 'link');
        const hasLabelPermission = label ? hasPermission(label, allMenu, 'web', 'label') : false;

        if (!hasLinkPermission && !hasLabelPermission) {
            toast.error("You don't have permission to access this page");
            return;
        }

        navigate(link);
    };

     const handleApplyNavigationApprove = (link, label = "") => {
        if (!warningDetails?.subscription_data?.web_access) {
            setNoAccessISOpen(true);
            return;
        }

        const hasLinkPermission = hasPermission("/payment_approval", allMenu, 'web', 'link');
       
        if (!hasLinkPermission) {
            toast.error("You don't have permission to access this page");
            return;
        }

        navigate(link);
    };


    useEffect(() => {
        
        if (dashboardFilterClear) {
            const obj = {
                ...getFiltersValues,
                branch_id: {}, // { label: "All", value: "" },
                lr_status: 0,
                lr_pagination: 1
            }
            dispatch(updateInputValue(obj))
            setDashboardFilterClear(false);
        }
    }, [dashboardFilterClear])

    const ewayBillApplyFilter = (value) => {

        if (!warningDetails?.subscription_data?.web_access) {
            setNoAccessISOpen(true);
            return;
        }


        const hasLinkPermission = hasPermission("/ebill", allMenu, 'web', 'link');

        if (!hasLinkPermission) {
            toast.error("You don't have permission to access this page");
            return;
        }

        const obj = {
            ...getEwayBillFilters,
            branch_id: getFiltersValues?.branch_id?.value ? getFiltersValues?.branch_id?.value : '',
            // start_date: selectedRange?.startDate,
            // end_date: selectedRange?.endDate,
            eway_bill_status: value,
            offset: 1
        }
        dispatch(updateEwayBillFilters(obj));
        navigate('/ebill');
    }

    const remainingDays = calculateRemainingDays(warningDetails.web_end_date)

    const paymentVerifyHandle = async (orderId) => {
        const payload = {
            order_id: orderId,
            company_id: StorageServices.getCompanyId(),
        };

        try {
            // setVerifyLoading(true);

            let res;

            res = await paymentVerifyApi(payload);

            if (res?.responseCode === 200) {
                const { status } = res.data;

                if (status === 1) {

                    setShowSuccess(true);
                    toast.success("Payment completed successfully!");
                    setTimeout(() => {
                        setShowSuccess(false);

                    }, 3000);

                } else if (status === 0) {

                    setShowPending(true);
                    toast.error("Payment is still pending. Please wait or contact support.");
                    setTimeout(() => {
                        setShowPending(false);

                    }, 3000);

                } else {
                    // Payment failed
                    setShowFailure(true);
                    toast.error("Payment failed. Please try again or contact support.");
                    setTimeout(() => {
                        setShowFailure(false);
                    }, 3000);
                }
            } else {
                // API call failed
                setShowFailure(true);
                toast.error("Unable to verify payment. Please contact support.");
                setTimeout(() => {
                    setShowFailure(false);
                }, 3000);
            }
        } catch (error) {
            // For network errors, treat as pending in case payment actually went through
            setShowPending(true);
            toast.error("Unable to verify payment status. Please contact support if amount was debited.");
            setTimeout(() => {
                setShowPending(false);
            }, 3000);
        } finally {
            // setVerifyLoading(false);
        }
    }

    const fetchBranchList = useCallback(async (search, page, limit) => {
        try {
            const response = await getBranchListApi({
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                offset: page,
                limit,
                search,
            });

            if (response?.responseCode === 200) {
                const vendors = response?.data?.branch_list?.map((vendor) => ({
                    ...vendor,
                    label: vendor.branch,
                    value: vendor._id
                }));

                return {
                    items: vendors,
                    total: response.data.total_record || vendors.length,
                };
            }

            toast.error(response?.responseMessage);
            return { items: [], total: 0 };
        } catch (error) {
            return { items: [], total: 0 };
        }
    }, []);

    return (
        <div className="llt_dashboard_bx">
            {/* <div className="mb-5">
                <div className='__subscr_planUp_bx'>
                    <img src={Images.WARN_ICON.default} alt="" />
                    <div>
                        {remainingDays > 0 ? (
                            <div>
                                <h6> Your Transport 360 Plan Subscription Ends in{" "}
                             {remainingDays} {remainingDays === 1 ? "Day" : "Days"}</h6>
                            </div>
                            // <p style={{fontWeight:500, fontSize:"16px",color:"#000"}}>
                               
                            // </p>
                        ) : (
                            <p style={{ color: "red" }}>
                                Your <strong>Transport 360</strong> Plan Subscription Has Expired!
                            </p>
                        )}
                        <p>Keep your Vehicles moving, customers happy, and business on time — upgrade now (upto 20% off!)</p>
                    </div>
                    <button className='anime-btn __upGrd_btn' onClick={() => navigate('/subscription')}>Upgrade plan <IoArrowForwardOutline /></button>
                </div>
            </div> */}
            <div className="llt_dash_heading">
                <h5>Welcome {userData?.user_detail?.full_name}</h5>
                <div className="llt_dash_branch_date">
                    <div className='widthInput_dash'>
                        <CityDropdownForTrip
                            label="Branch"
                            placeholder="Branch"
                            fetchData={fetchBranchList}
                            pageSize={20}
                            selectedItem={getFiltersValues?.branch_id?.label ? getFiltersValues?.branch_id : {}}
                            onChange={(data) => onhandleSelect(data, 'branch_id')}
                            isClearOption={getFiltersValues?.branch_id?.value ? true : false}
                            isClearHandleChange={(e) => onhandleSelect({ label: "All", value: "" }, 'branch_id')}
                        // disabled={isOpen?.isDetails ? true : false}
                        // error={formError['manufacture_id.label']}
                        // errorMessage={formError['manufacture_id.label']}
                        // isAddButton={true}
                        // addButtonAction={(e) => addNewManufacturerHandler(e)}
                        />
                        {/* <CustomSelect
                            options={dropdownBranchList?.map((el) => {
                                return {
                                    label: el?.branch,
                                    value: el?._id,
                                    firm_id: el?.firm_id
                                }
                            })}
                            name="branch_id"
                            label="Select Branch"
                            placeholder="Select Branch"
                            value={getFiltersValues?.branch_id?.label ? getFiltersValues?.branch_id : {}}
                            onSelect={(data) => onhandleSelect(data, 'branch_id')}
                        /> */}
                    </div>

                    <div>
                        <CommonDateRange
                            initialStartDate={getFiltersValues?.start_date}
                            initialEndDate={getFiltersValues?.end_date}
                            onApply={handleApply}
                            isDefaultToday={true}
                        // datePrefield={(!dashboardData?.start_date && !dashboardData?.end_date) ? false : true}
                        />
                    </div>

                </div>
            </div>

            <div className='__warnMain_bxs'>
                <BsExclamationCircle />
                <p>Action required</p>
                <div className='__req_actTags'>{dashboardData?.lr_status?.pod_overdue > 0 ? dashboardData?.lr_status?.pod_overdue : 0} <span> PODs overdue </span></div>
                <div className='__req_actTags'>{dashboardData?.vehicle_doc_status?.expired > 0 ? dashboardData?.vehicle_doc_status?.expired : 0} <span> Documents expired</span></div>
                <div className='__req_actTags'>{dashboardData?.lr_status?.expiring_today > 0 ? dashboardData?.lr_status?.expiring_today : 0} <span> E-way bills expiring today</span></div>
            </div>

            <div className="row dash_row">
                <div className="col-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="llt_dash_lr_stats">
                        <h6>LR Status</h6>

                        <div className="llt_dash_lr_r1">
                            <div className="llt_dash_lr_sts_one">
                                <span className="llt_dash_span_one"></span> <p>LR Created</p>
                            </div>
                            <button className="llt_dash_btn_one" onClick={() => statusWithNavigate(0, true)}>{dashboardData?.lr_status?.lr_created}</button>
                        </div>
                        <div className="llt_dash_lr_r1">
                            <div className="llt_dash_lr_sts_one">
                                <span className="llt_dash_span_two"></span> <p>LR Pending</p>
                            </div>
                            <button className="llt_dash_btn_two" onClick={() => statusWithNavigate(1, false)}>{dashboardData?.lr_status?.pending_lr}</button>
                        </div>
                        <div className="llt_dash_lr_r1">
                            <div className="llt_dash_lr_sts_one">
                                <span className="llt_dash_span_three"></span>
                                <p>In-Transit</p>
                            </div>
                            <button className="llt_dash_btn_three" onClick={() => statusWithNavigate(3, false)}>{dashboardData?.lr_status?.in_transit}</button>
                        </div>
                        <div className="llt_dash_lr_r1">
                            <div className="llt_dash_lr_sts_one">
                                <span className="llt_dash_span_four"></span>
                                <p>At Party Point</p>
                            </div>
                            <button className="llt_dash_btn_four" onClick={() => statusWithNavigate(4, false)}>{dashboardData?.lr_status?.at_party_point}</button>
                        </div>
                        <div className="llt_dash_lr_r1">
                            <div className="llt_dash_lr_sts_one">
                                <span className="llt_dash_span_five"></span> <p>Delivered</p>
                            </div>
                            <button className="llt_dash_btn_five" onClick={() => statusWithNavigate(5, false)}>{dashboardData?.lr_status?.delivered}</button>
                        </div>
                        <div className="llt_dash_lr_r1">
                            <div className="llt_dash_lr_sts_one">
                                <span className="llt_dash_span_six"></span> <p>Bill Raised</p>
                            </div>
                            <button className="llt_dash_btn_six" onClick={() => statusWithNavigate(6)}>{dashboardData?.lr_status?.bill_raised}</button>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="llt_dash_lr_stats" style={{ position: 'relative' }}>
                        <h6 style={{ marginBottom: '0px', paddingBottom: '0px' }}>Dispatch Summary</h6>
                        <div className="llt_dash_dispatch">

                            <PieCharts
                                dataList={
                                    chartData?.length > 0
                                        ? chartData
                                        : []
                                }
                            />
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="llt_dash_pod_vehicle">
                        <div className="llt_dash_pod">
                            <h6 className='__headLine_dp'>POD Status</h6>
                            <div className="llt_dash_pod_data">
                                <div
                                    className="llt_dash_pod_d1 _avPointer"
                                    onClick={() => handleApplyFilter({ value: 2, label: "Received" })}>
                                    <div className='__growUp_pod'>
                                        <img src={Images.GRAPHUP.default} alt="graph up" />
                                    </div>
                                    <div>
                                        <h5>{dashboardData?.lr_status?.pod_received}</h5>
                                        <p>POD Received</p>
                                    </div>
                                </div>
                                <div
                                    className="llt_dash_pod_d1 _avPointer"
                                    onClick={() => handleApplyFilter({ value: 1, label: "Pending" })}>
                                    <div className='__pendingTime_pod'>
                                        <img src={Images.PENDING_HISPORY.default} alt="pending pod" />
                                    </div>
                                    <div>
                                        <h5>{dashboardData?.lr_status?.pod_pending}</h5>
                                        <p>POD Pending</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="llt_dash_pod">
                            <h6 className='__headLine_dp'>Vehicle Document</h6>
                            <div className="llt_dash_pod_data">
                                <div className="llt_dash_vehicle_d1">
                                    <div className='__expireVhl_doc'>
                                        <img src={Images.NEAR_EXPIRE_VHL.default} alt="Near Expiry" />
                                    </div>
                                    <div>
                                        <p>Expiring soon</p>
                                        <h6> {dashboardData?.vehicle_doc_status?.expiring_soon} </h6>
                                    </div>
                                </div>
                                <div className="llt_dash_vehicle_d1">
                                    <div className='__expireVhl_doc'>
                                        <img src={Images.EXPIRED_VHL.default} alt="Expired Vehicle" />
                                    </div>
                                    <div>
                                        <p>Expired</p>
                                        <h6> {dashboardData?.vehicle_doc_status?.expired} </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="__dash_quick_access">
                        <h6 className='__headLine_dp'>Quick Access</h6>

                        <div className='__dash_quickBtn_bx' >
                            <Link>
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/plan/planlist')}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_PLAN.default} alt="My Plans" />
                                    </div>
                                    My Plans
                                </button>
                            </Link>
                            <Link >
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/lr/addlr',)}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_LR.default} alt="LR/ Bilty" />
                                    </div>
                                    LR/ Bilty
                                </button>
                            </Link>
                            <Link>
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/trip/addtrip')}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_TRIP.default} alt="Trip" />
                                    </div>
                                    Trip
                                </button>
                            </Link>
                            <Link >
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/ebill')}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_EWAY.default} alt="Eway" />
                                    </div>
                                    Eway
                                </button>
                            </Link>
                            <Link >
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/account/consignor')}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_PARTY.default} alt="Party" />
                                    </div>
                                    Party
                                </button>
                            </Link>
                            <Link >
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/account/supplier')}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_SUPPLIER.default} alt="Supplier" />
                                    </div>
                                    Supplier
                                </button>
                            </Link>
                            <Link >
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/account/driver')}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_DRIVER.default} alt="Driver" />
                                    </div>
                                    Driver
                                </button>
                            </Link>
                            <Link>
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/account/vehicle')}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_TRUCK.default} alt="Trucks" />
                                    </div>
                                    Trucks
                                </button>
                            </Link>
                            <Link >
                                <button className='__dash_quickBtn ' onClick={() => handleApplyNavigation('/accounting/staff', "Staff")}>
                                    <div className='__dash_quickIconBx'>
                                        <img src={Images.DASH_PARTY.default} alt="Staff" />
                                    </div>
                                    Staff
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="llt_dash_payment">
                        <h5>Account Details</h5>
                        <div className="llt_dash_Account_bx">
                            {dashboardData?.accounting_list?.length > 0 ? dashboardData?.accounting_list?.map((item, indx) => {

                                return (

                                    <Link className="llt_dash_Account_bx_1" style={{ "textDecoration": "none" }} key={indx}
                                        onClick={() => handleApplyNavigation("/accounting/transactions/bank_transaction_list", "Accounting")}
                                        state={{
                                            data: {
                                                account_id: item?._id,
                                            },
                                        }}>
                                        <p>{item?.bank}</p>
                                        <a href=""> ₹ {item?.balance ? item?.balance?.toFixed(2) : 0.00} </a>
                                    </Link>
                                )
                            }) :
                                <>
                                    <div className="llt_dash_Account_bx_1">
                                        <p>Axis Bank</p>
                                        <a href=""> No bank found </a>
                                    </div>
                                    <div className="llt_dash_Account_bx_1">
                                        <p>Kotak Bank</p>
                                        <a href=""> No bank found </a>
                                    </div>
                                    <div className="llt_dash_Account_bx_1">
                                        <p>Yes Bank</p>
                                        <a href=""> No bank found </a>
                                    </div>
                                    <div className="llt_dash_Account_bx_1">
                                        <p>Axis Bank</p>
                                        <a href=""> No bank found </a>
                                    </div>
                                    <div className="llt_dash_Account_bx_1">
                                        <p>Kotak Bank</p>
                                        <a href=""> No bank found </a>
                                    </div>
                                    <div className="llt_dash_Account_bx_1">
                                        <p>Yes Bank</p>
                                        <a href=""> No bank found </a>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="llt_dash_payment" style={{ overflow: 'hidden' }}>
                        <h5>Payment Approval</h5>
                        <div className="llt_dash_payment_bx">
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=1')}>
                                <div className='__dashPay_pending'><h6>{dashboardData?.payment_approval_status?.pending}</h6></div>
                                <p>Pending</p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=2')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.hold}</h6></div>
                                <p>On Hold</p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=3')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.approved}</h6></div>
                                <p>Approved</p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=6')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.payment_from_CB}</h6></div>
                                <p> Pay from Bank </p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=7')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.pending}</h6></div>
                                <p> Pending from Bank </p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=8')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.CB_transaction_initiated}</h6></div>
                                <p> Transaction Initiated </p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=9')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.CB_transaction_failed}</h6></div>
                                <p>Transaction Failed</p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=3')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.CB_under_approval}</h6></div>
                                <p> Under Approval </p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=5')}>
                                <div className='__dashPay_normal'><h6>{dashboardData?.payment_approval_status?.completed}</h6></div>
                                <p>Completed</p>
                            </div>
                            <div className="llt_dash_payment_bx_1 _avPointer" onClick={() => handleApplyNavigationApprove('/payment_approval?tab=4')}>
                                <div className='__dashPay_reject'><h6>{dashboardData?.payment_approval_status?.rejected}</h6></div>
                                <p>Rejected</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-lg-6 col-xl-4">
                    <div className="llt_dash_payment">
                        <h5> EWay Bill Status </h5>
                        <div className="llt_dash_eway_bx">
                            <div className="llt_dash_eway_bx_1 llt_dasheway_bill_1 _avPointer" onClick={() => ewayBillApplyFilter(2)}>
                                <h6>{dashboardData?.lr_status?.active_eway > 0 ? dashboardData?.lr_status?.active_eway : 0}</h6>
                                <p> Active Eway </p>
                            </div>

                            <div className="llt_dash_eway_bx_1 llt_dasheway_bill_2 _avPointer" onClick={() => ewayBillApplyFilter(1)}>
                                <h6>{dashboardData?.lr_status?.without_eway > 0 ? dashboardData?.lr_status?.without_eway : 0}</h6>
                                <p> Without Eway </p>
                            </div>

                            <div className="llt_dash_eway_bx_1 llt_dasheway_bill_3 _avPointer" onClick={() => ewayBillApplyFilter(4)}>
                                <h6>{dashboardData?.lr_status?.expiring_today > 0 ? dashboardData?.lr_status?.expiring_today : 0}</h6>
                                <p> Expiring Today </p>
                            </div>

                            <div className="llt_dash_eway_bx_1 llt_dasheway_bill_4 _avPointer" onClick={() => ewayBillApplyFilter(5)}>
                                <h6>{dashboardData?.lr_status?.expired > 0 ? dashboardData?.lr_status?.expired : 0}</h6>
                                <p> Expired </p>
                            </div>

                            {/* <div className="llt_dash_eway_bx_1 llt_dasheway_bill_5">
                                <h6>{dashboardData?.lr_status?.not_found > 0 ? dashboardData?.lr_status?.not_found : 0}</h6>
                                <p>Not Found</p>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>

        </div >
    )
}

export default MainDashboard